import { render, staticRenderFns } from "./TeamMemberTile.vue?vue&type=template&id=96bfc654&scoped=true&"
import script from "./TeamMemberTile.vue?vue&type=script&lang=js&"
export * from "./TeamMemberTile.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberTile.vue?vue&type=style&index=0&id=96bfc654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bfc654",
  null
  
)

export default component.exports